import cookie from 'js-cookie';

export default () => cookie.get('xo-session-token');
